import React from 'react'
import { Route, Switch } from 'react-router-dom'
import CreateCommunity from './CreateCommunity'
import ListCommunities from './ListCommunities'
import EditCommunity from './EditCommunity'

const Communities = ({ match }) => (
  <div>
    <Route exact path={match.url} component={ListCommunities} />
    <Switch>
      <Route exact path={`${match.url}/add`} component={CreateCommunity} />
      <Route
        path={`${match.url}/:id`}
        render={props => <EditCommunity {...props} />}
      />
    </Switch>
  </div>
)

export default Communities
